import React, { Component } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './NavMenu.css';
import '../custom.css';
import '../main.scss';
import '../fontawesome-free-5.15.1-web/css/fontawesome.css';
import '../fontawesome-free-5.15.1-web/css/solid.css';
import '../fontawesome-free-5.15.1-web/css/brands.css';

const MENU = [
  { to: '/', icon: 'fas fa-home', label: 'หน้าแรก' },
  { to: '/programs/search', icon: 'fas fa-suitcase-rolling', label: 'โปรแกรมท่องเที่ยว' },
  { to: '/programs/search?hashtag=ทัวร์ต่างประเทศ', icon: 'fas fa-globe', label: 'ทัวร์ต่างประเทศ' },
  { to: '/programs/search?hashtag=ทัวร์ในประเทศ', icon: 'fas fa-map-marked-alt', label: 'ทัวร์ในประเทศ' },
  { to: '/group-request?mode=group', icon: 'fas fa-users', label: 'จัดกรุ๊ปส่วนตัว' },
  { to: '/group-request?mode=self', icon: 'fas fa-user-friends', label: 'ท่องเที่ยวด้วยตัวเอง' },
  { to: '/programs/search?hashtag=PROMOTION', icon: 'fas fa-tags', label: 'โปรโมชั่นพิเศษ', highlight: true },
  { to: '/aboutUs', icon: 'fas fa-info-circle', label: 'เกี่ยวกับเรา' }
];

export function NavMenu(props) {
  var location = useLocation();
  return <NavMenuInner {...props} locationKey={location.pathname + location.search} />;
}

class NavMenuInner extends Component {
  static displayName = 'NavMenu';

  constructor(props) {
    super(props);
    this.state = { mobileOpen: false, scrolled: false, setting: {} };
    this.toggleMobile = this.toggleMobile.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    fetch('api/sitesetting')
      .then(r => r.ok ? r.json() : {})
      .then(setting => this.setState({ setting: setting || {} }))
      .catch(() => {});
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    // Hysteresis: turn ON at >120, OFF at <40 — prevents flicker when shrink causes layout shift
    var cur = this.state.scrolled;
    var next = cur ? y > 40 : y > 120;
    if (next !== cur) this.setState({ scrolled: next });
  }

  toggleMobile() {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  }

  activeIndex() {
    if (typeof window === 'undefined') return -1;
    var path;
    try { path = decodeURIComponent(window.location.pathname + window.location.search); }
    catch { path = window.location.pathname + window.location.search; }
    // exact match wins; otherwise longest pathname-only match
    var best = -1, bestLen = -1;
    for (var i = 0; i < MENU.length; i++) {
      var to = MENU[i].to;
      if (to === '/') {
        if (path === '/' || path === '') return i;
        continue;
      }
      if (path === to) return i;
      // Only fall back to path-only match if menu has no query
      var toBase = to.split('?')[0];
      if (to === toBase && (path === toBase || path.startsWith(toBase + '?'))) {
        if (toBase.length > bestLen) { best = i; bestLen = toBase.length; }
      }
    }
    return best;
  }

  render() {
    var { mobileOpen, scrolled, setting } = this.state;

    return (
      <header style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fff', boxShadow: scrolled ? '0 4px 18px rgba(0,0,0,0.08)' : '0 1px 4px rgba(0,0,0,0.04)', transition: 'all 0.3s ease' }}>
        <style>{`
          .nm-top { display:flex; align-items:center; justify-content:space-between; max-width:1280px; margin:0 auto; padding:10px 20px; transition: all 0.3s ease; }
          .nm-top.scrolled { padding:6px 20px; }
          .nm-logo { height:64px; transition: height 0.3s ease; }
          .nm-top.scrolled .nm-logo { height:44px; }
          .nm-slogan { height:48px; transition: height 0.3s ease; }
          .nm-top.scrolled .nm-slogan { height:34px; }
          .nm-nav { background: linear-gradient(90deg,#c82333 0%,#9d1a26 100%); }
          .nm-nav-inner { max-width:1280px; margin:0 auto; display:flex; align-items:center; justify-content:center; gap:4px; padding:0 20px; flex-wrap:wrap; }
          .nm-link, .nm-link:hover, .nm-link:focus, .nm-link:active { text-decoration:none !important; }
          .nm-link { display:inline-flex; align-items:center; gap:7px; padding:14px 14px; color:rgba(255,255,255,0.9); font-size:14px; font-weight:600; letter-spacing:0.2px; position:relative; transition: all 0.2s; white-space:nowrap; }
          .nm-link:hover { color:#fff; }
          .nm-link:hover::after, .nm-link.active::after { content:''; position:absolute; left:14px; right:14px; bottom:8px; height:2px; background:#ffd966; border-radius:2px; }
          .nm-link.active { color:#fff; }
          .nm-link.highlight { background:#ffd966; color:#b8241a; margin:6px 4px; border-radius:6px; padding:8px 14px; font-weight:700; }
          .nm-link.highlight:hover { background:#fff; color:#b8241a; }
          .nm-link.highlight::after, .nm-link.highlight:hover::after { display:none; }
          .nm-cta { display:flex; align-items:center; gap:10px; }
          .nm-cta a { color:#555; text-decoration:none; font-size:13px; font-weight:600; display:inline-flex; align-items:center; gap:6px; padding:6px 10px; border-radius:6px; transition: all 0.2s; }
          .nm-cta a:hover { background:#f5f5f5; color:#c82333; }
          .nm-cta .nm-call { background:#c82333; color:#fff; padding:8px 14px; border-radius: 22px; }
          .nm-cta .nm-call:hover { background:#9d1a26; color:#fff; }
          .nm-burger { display:none; border:none; background:transparent; font-size:22px; color:#c82333; cursor:pointer; }
          @media (max-width: 960px) {
            .nm-cta { display:none; }
            .nm-burger { display:block; }
            .nm-nav-inner { flex-direction:column; align-items:stretch; max-height: 0; overflow:hidden; transition: max-height 0.3s ease; }
            .nm-nav-inner.open { max-height: 600px; padding-top:6px; padding-bottom:6px; }
            .nm-link { justify-content:flex-start; padding:12px 20px; border-bottom:1px solid rgba(255,255,255,0.1); }
            .nm-link:hover::after, .nm-link.active::after { display:none; }
            .nm-link.active { background:rgba(255,255,255,0.15); }
            .nm-link.highlight { margin:6px 14px; }
          }
        `}</style>

        <div className={'nm-top ' + (scrolled ? 'scrolled' : '')}>
          <div style={{ display:'flex', alignItems:'center', gap:18 }}>
            <Link to="/" style={{ display:'flex', alignItems:'center' }}>
              <img src="/images/ANT_LOGO.png" alt="ANT" className="nm-logo" />
            </Link>
            <img src="/images/slocan.png" alt="" className="nm-slogan d-none d-md-block" style={{ objectFit: 'contain' }} />
          </div>

          <div className="nm-cta">
            {setting.phone && (
              <a href={'tel:' + setting.phone} className="nm-call">
                <i className="fas fa-phone-alt"></i> {setting.phone}
              </a>
            )}
            {setting.line_id && (
              <a href={setting.line_id.startsWith('http') ? setting.line_id : 'https://line.me/R/ti/p/' + encodeURIComponent(setting.line_id)} target="_blank" rel="noopener noreferrer" title="LINE">
                <i className="fab fa-line" style={{ color:'#06c755', fontSize:18 }}></i>
              </a>
            )}
            {setting.facebook_url && (
              <a href={setting.facebook_url} target="_blank" rel="noopener noreferrer" title="Facebook">
                <i className="fab fa-facebook" style={{ color:'#1877f2', fontSize:18 }}></i>
              </a>
            )}
            {setting.instagram_url && (
              <a href={setting.instagram_url} target="_blank" rel="noopener noreferrer" title="Instagram">
                <i className="fab fa-instagram" style={{ color:'#e4405f', fontSize:18 }}></i>
              </a>
            )}
          </div>

          <button className="nm-burger" onClick={this.toggleMobile} aria-label="Menu">
            <i className={mobileOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
          </button>
        </div>

        <nav id="navbar-main" className="nm-nav">
          <div className={'nm-nav-inner ' + (mobileOpen ? 'open' : '')}>
            {(() => {
              var active = this.activeIndex();
              return MENU.map((m, i) => (
                <Link key={i} to={m.to}
                  className={'nm-link ' + (m.highlight ? 'highlight ' : '') + (i === active ? 'active' : '')}
                  onClick={() => this.setState({ mobileOpen: false })}>
                  <i className={m.icon}></i> {m.label}
                </Link>
              ));
            })()}
          </div>
        </nav>
      </header>
    );
  }
}
